import {getFetchDate} from '~/helpers/prices/_utils/prices'

export const state = () => ({
  pricesAllServers: [],
  allServersFetchDate: ''
})

export const mutations = {
  setAllServersPrices(state, value) {
    state.pricesAllServers = [].concat(value)
  },
  setAllServersFetchDate(state, value) {
    state.allServersFetchDate = value
  }
}

export const actions = {
  async fetchAllServersPrices(store, options) {
    await store.dispatch('rest-client/servers/chipcore/fetchChipcorePrices', options, {root: true})
    await store.dispatch('rest-client/servers/servers/fetchServersPrices', options, {root: true})

    store.commit('setAllServersPrices', [
        ...store.rootGetters['rest-client/servers/chipcore/getChipcorePrices'],
        ...store.rootGetters['rest-client/servers/servers/getServersPrices']
    ])

    store.commit('setAllServersFetchDate', getFetchDate())
  }
}

export const getters = {
  getAllServersFetchDate(state) {
    return state.allServersFetchDate
  },
  getAllServersPrices(state) {
    return state.pricesAllServers
  }
}